// utils/showToast.js
import { toast } from 'react-toastify';

export const showToast = (msg, type, duration = 2000) => {
  toast(msg, {
    position: "bottom-center",
    autoClose: duration,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,  
    draggable: false,     
    theme: "light",
    className:
      type === "success"
        ? "text-success toast-style-1"
        : "text-danger toast-style-1",
  });
};
